
import { Vue, Component, Prop } from 'vue-property-decorator';
import TextMenu from '@/components/menu/TextMenu.vue';

@Component<MenuItemResults>({
	components: {
		TextMenu
	}
})
export default class MenuItemResults extends Vue {
	@Prop({ type: Object, required: true, default: () => {} }) private menu!: Menu;
	@Prop({ type: Array, required: true, default: () => [] }) private items!: MenuItem[];
	@Prop({ type: String, required: false, default: 'vertical' }) private cardStyle!: string;


	/**
	 * Open the item viewer
	 *
	 * @param {MenuItem} menuItem
	 * @return {void}
	 */
	private clickHandler(menuItem: MenuItem): void {
		this.$emit('on-click', menuItem);
	}
}
